<router-outlet />
<p-toast [breakpoints]="{ '530px': { width: '90%', right: '0', left: '0', margin: 'auto' } }" />
